import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDocumentTitle } from "@eis-poc/lib-discover-medical-mfes";

import MfeRouteFallback from "./MfeRouteFallback";
import MfeWrapper from "../MfeWrapper";
import getPageTitle from "../../utils/getPageTitle";
import { RouteContent } from "../RouteContent/RouteContent.styled";
import FullSpinner from "../FullSpinner";
import { scrollToTop } from "../../utils/scrollToTop";

const isFluidWrapper = (name) =>
  [
    "PlatformHome",
    "PlatformHomeDHE",
    "PlatformHomeDMP",
    "PlatformHomeDMX",
    "PlatformContinuingEducation"
  ].includes(name);
const isFlexCell = (name) => ["PlatformContinuingEducation"].includes(name);

const MfeRoute = ({ location, mfeId, requireLogin, productName, eventBus }) => {
  const { setDocumentTitle } = useDocumentTitle(productName);
  const { pathname, search } = location;

  // TODO: Remove this when a permanent solution is implemented in RCL.
  useEffect(() => {
    document.body.classList.remove("RCL_PinBody__menu");
    scrollToTop();
  }, []);

  useEffect(() => {
    const pageTitle = getPageTitle(pathname, search);
    setDocumentTitle([pageTitle]);
  }, [pathname, search]);

  const SpinnerMemo = React.useMemo(() => <FullSpinner />, []);

  if (!mfeId && typeof window !== "undefined" && requireLogin) {
    const returnToUrl = encodeURIComponent(window.location.href);
    window.location.assign(`/login?returnToUrl=${returnToUrl}`);
    return <FullSpinner data-testid="spinner-wrap" />;
  }

  return mfeId ? (
    <RouteContent
      cell={!isFluidWrapper(mfeId)}
      $isFluid={isFluidWrapper(mfeId)}
      $isFlexCell={isFlexCell(mfeId)}
      role="main"
    >
      <MfeWrapper
        name={mfeId}
        loadingElement={SpinnerMemo}
        eventBus={eventBus}
      />
    </RouteContent>
  ) : (
    <RouteContent cell>
      <MfeRouteFallback />
    </RouteContent>
  );
};

MfeRoute.defaultProps = {
  location: {}
};

MfeRoute.propTypes = {
  location: PropTypes.object,
  mfeId: PropTypes.string,
  productName: PropTypes.string,
  requireLogin: PropTypes.bool,
  eventBus: PropTypes.object.isRequired
};

export default MfeRoute;
